import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  SxProps,
  Theme,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Stats } from '../../types/Report.type';

interface StatCardProps {
  stat: Stats;
  sx?: SxProps<Theme>;
}

const StatCard: React.FC<StatCardProps> = ({ stat, sx }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        boxShadow: theme.shadows[2],
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: theme.shadows[4],
        },
        ...sx,
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 2 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            variant="body1"
            color="text.secondary"
            fontWeight="medium"
          >
            {stat.title}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 1,
              borderRadius: '50%',
              backgroundColor: `${stat.color}15`,
              color: stat.color,
            }}
          >
            {stat.icon}
          </Box>
        </Box>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
          {stat.value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatCard;
